import { Input } from 'components/atoms';
import { FormInput } from 'components/molecules';
import LabelFormStep from 'components/templates/label-form-step/LabelFormStep';
import { useFormikContext } from 'formik';
import { useTranslation } from 'react-i18next';
import { useGetCountries } from 'services/enums';
import { CUSTOMER_TYPE, ILabelForm } from 'services/labels/types';
import { useStateStorage } from 'store/state';

const LabelBankStep = () => {
  const { t } = useTranslation();
  const formik = useFormikContext<ILabelForm>();
  const { countries: storeCountries } = useStateStorage();
  const { data: fetchedCountries } = useGetCountries(!storeCountries?.length);
  const countries = storeCountries?.length ? storeCountries : (fetchedCountries ?? []);

  const countrySelectOptions =
    countries?.map(country => ({
      label: t(`countries.${country.codeAlfa2}`),
      value: country.codeAlfa2,
    })) ?? [];

  return (
    <LabelFormStep
      header={t('label.form.bank.header')}
      description={t('label.form.bank.description')}>
      {formik.values.customerType === CUSTOMER_TYPE.Physical ? (
        <FormInput.Text
          name='personalId'
          label={t('input.label.personalId')}
          wrapperClassName='max-w-full'
        />
      ) : (
        <FormInput.Text
          name='companyId'
          label={t('input.label.companyId')}
          wrapperClassName='max-w-full'
        />
      )}
      <FormInput.Text
        name='bankAccountNumber'
        label={t('input.label.bankAccountNumber')}
        wrapperClassName='max-w-full'
      />
      {formik.values.customerType === CUSTOMER_TYPE.Physical ? (
        <FormInput.Select
          name={'personalIdCountryAlfa2'}
          label={t('input.label.country')}
          options={countrySelectOptions}
          wrapperClassName='max-w-full'
        />
      ) : (
        <FormInput.Select
          name={'companyCountryAlfa2'}
          label={t('input.label.country')}
          options={countrySelectOptions}
          wrapperClassName='max-w-full'
        />
      )}
      <Input.ComplexWrapper>
        <FormInput.Text
          name='bankName'
          label={t('input.label.bankName')}
        />
        <FormInput.Text
          name='swift'
          label={t('input.label.swift')}
        />
      </Input.ComplexWrapper>
    </LabelFormStep>
  );
};

export default LabelBankStep;
